import React, { PropTypes } from 'react';
import Gallery from 'common/components/gallery';
import ResultTile from 'presentations/containers/result_tile';
import EditRevisionsModal from 'presentations/containers/edit_revisions_modal';

const Results = ({ revisions, toggleEditModal, children, handleTileSelect }) => {
  return (
    <div className="tab-content results">
      <div className="tab-actions">
        <button className="btn btn-secondary btn-sm" onClick={toggleEditModal}>
          Edit Entries
        </button>
      </div>
      <Gallery
        classes="row small-up-1 project-entries-gallery list presentation-results"
        list={revisions}
        tile={ResultTile}
        onTileSelect={handleTileSelect}
      />
      <EditRevisionsModal />
      { children }
    </div>
  );
}

Results.propTypes = {
  toggleEditModal: PropTypes.func.isRequired,
  handleTileSelect: PropTypes.func.isRequired,
  revisions: PropTypes.array.isRequired,
};

export default Results;



// WEBPACK FOOTER //
// ./presentations/components/results.jsx